export default function ReviewCta() {
  return (
    <section className="w-full py-16" style={{ backgroundColor: '#f9fdfb' }}>
      <div className="max-w-7xl mx-auto px-6">
        <div
          className="rounded-2xl overflow-hidden relative"
          style={{ backgroundColor: '#1a3d35' }}
        >
          <div className="absolute inset-0 opacity-10">
            <img
              src="https://readdy.ai/api/search-image?query=abstract%20organic%20botanical%20leaf%20pattern%20subtle%20texture%20soft%20green%20tones%20minimal%20repeat%20pattern%20gentle%20nature%20motif%20clean%20background&width=1200&height=300&seq=review-cta-bg&orientation=landscape"
              alt=""
              className="w-full h-full object-cover object-center"
            />
          </div>
          <div className="relative z-10 flex flex-col md:flex-row items-center justify-between gap-8 px-8 md:px-14 py-10 md:py-12">
            <div>
              <p className="text-sm font-semibold tracking-widest uppercase mb-3 text-white/60">KOREA CARERS</p>
              <h3 className="text-2xl md:text-3xl font-bold text-white mb-3 leading-snug">
                간병 걱정 없이, 지금 바로<br />코리아케어러스와 함께하세요
              </h3>
              <p className="text-sm text-white/70 leading-relaxed">
                간병인 매칭부터 간병비 보험청구까지, 전문 상담사가 도와드립니다.
              </p>
            </div>
            <div className="flex flex-col sm:flex-row gap-3 flex-shrink-0">
              <a
                href="/register"
                className="px-7 py-3 rounded-lg text-sm font-semibold whitespace-nowrap cursor-pointer text-center transition-all"
                style={{ backgroundColor: '#2E7D6B', color: '#fff' }}
              >
                <i className="ri-file-list-3-line mr-2"></i>
                등록하기
              </a>
              <a
                href="tel:15668654"
                className="px-7 py-3 rounded-lg text-sm font-semibold whitespace-nowrap cursor-pointer text-center border border-white/30 text-white transition-all hover:bg-white/10"
              >
                <i className="ri-phone-line mr-2"></i>
                1566-8654 전화 상담
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
